import { getElapsedHours } from '../utilities/DateHelpers';

const toDateOnly = (dailyTimesheet) =>
    !dailyTimesheet ? '2000-01-01' : dailyTimesheet.date.substring(0, 10);

const toSafeDate = (dailyTimesheet, time) =>
    `${toDateOnly(dailyTimesheet)}T${time}Z`;

export const calculateTimesheetDetailElapsedHours = (
    dailyTimesheet,
    dailyTimesheetDetail
) => {
    if (
        !dailyTimesheetDetail ||
        !dailyTimesheetDetail.startTime ||
        !dailyTimesheetDetail.endTime
    ) {
        return 0;
    }

    return getElapsedHours(
        toSafeDate(dailyTimesheet, dailyTimesheetDetail.startTime),
        toSafeDate(dailyTimesheet, dailyTimesheetDetail.endTime)
    );
};

export const calculateTimesheetElapsedHours = (dailyTimesheet) =>
    dailyTimesheet && dailyTimesheet.dailyTimesheetDetails.length
        ? dailyTimesheet.dailyTimesheetDetails.reduce(
              (partialSum, dtd) =>
                  calculateTimesheetDetailElapsedHours(dailyTimesheet, dtd) +
                  partialSum,
              0
          )
        : 0;

export const isValid = (dailyTimesheet) =>
    dailyTimesheet &&
    calculateTimesheetElapsedHours(dailyTimesheet) > 0 &&
    calculateTimesheetElapsedHours(dailyTimesheet) < 24;
